import React from 'react'

export default function DownloadFile({ url }) {
    return (
        <div style={{ marginTop: 10 }}>
            <a style={{color:"blue"}} href={url} target="_blank" rel="noopener noreferrer" >Download File</a>
        </div>
    )
}
